import { useLang } from "@/lib/i18n";

const BOOKING = {
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  accepted: "bg-sky-50 text-sky-800 border-sky-200",
  rejected: "bg-rose-50 text-rose-700 border-rose-200",
  disputed: "bg-orange-50 text-orange-800 border-orange-300",
  confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  completed: "bg-slate-100 text-slate-700 border-slate-300",
  cancelled: "bg-rose-50 text-rose-700 border-rose-200",
};
const PAYMENT = {
  pending: "bg-white text-slate-600 border-slate-300",
  collected: "bg-sky-50 text-sky-800 border-sky-200",
  confirmed: "bg-emerald-50 text-emerald-800 border-emerald-200",
  disputed: "bg-orange-50 text-orange-800 border-orange-300",
  refund_pending: "bg-amber-50 text-amber-800 border-amber-200",
  void: "bg-slate-50 text-slate-400 border-slate-200",
  paid: "bg-emerald-50 text-emerald-800 border-emerald-200",
  refunded: "bg-sky-50 text-sky-800 border-sky-200",
  partially_refunded: "bg-sky-50 text-sky-800 border-sky-200",
};

export const StatusBadge = ({ status, testId }) => {
  const { t } = useLang();
  return (
    <span data-testid={testId || "booking-status-badge"} className={`inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold ${BOOKING[status] || BOOKING.completed}`}>
      {t(`status_${status}`).startsWith("status_") ? status : t(`status_${status}`)}
    </span>
  );
};

export const PaymentBadge = ({ status, testId }) => (
  <span data-testid={testId || "payment-status-badge"} className={`inline-flex rounded-full border px-2.5 py-0.5 font-mono text-[11px] uppercase tracking-wider ${PAYMENT[status] || PAYMENT.unpaid}`}>
    cash: {status.replace("_", " ")}
  </span>
);
